import { className } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

const CurrentPeriod = () => {
  return (
    <div className="p-4">
      <Panel title="Current period">
        <div className="grid grid-cols-2 gap-x-8">
          <div className="col-span-2 text-sm text-theme-gray-500 dark:text-theme-gray-400 pb-2">
            Last payment ($USD 60.00) was successful on 2018-12-01.
          </div>
          <div className="col-span-2 text-sm text-theme-gray-500 dark:text-theme-gray-400 pb-2">
            Paid for service until 2019-01-01 (one month).
          </div>
          <div className="col-span-2 pb-6">
            <button
              className={`${className} float-start`}
              type="submit"
              onClick={() => console.log('click button')}
            >
              View invoice
            </button>
            <button
              className={`${className} float-end`}
              type="submit"
              onClick={() => console.log('click button')}
            >
              View payment
            </button>
          </div>
        </div>
      </Panel>
    </div>
  )
}

export default CurrentPeriod
